module.exports = __webpack_public_path__ + "img/pro_seven_1.d48adef9.jpg";